<template>
  <!-- What a sound costs you (the app's LicenseChip): "Free", a price,
       "Not for sale" (rights reserved with no price, decision 15), "Bonus"
       (comes with its pack) or "Owned"; "neutral" is any other list-row
       word on the same chip (a ledger's "Pending"), so one list has one
       chip size (MyAudio: 22 px, 12/600 on touch). Not interactive. -->
  <span class="sale-chip" :class="`sale-chip--${kind}`">{{ label }}</span>
</template>

<script>
export default {
  name: "SaleChip",
  props: {
    kind: {
      type: String,
      default: "free",
      validator: (v) => ["free", "neutral", "price", "muted", "bonus", "owned"].includes(v),
    },
    label: { type: String, required: true },
  },
};
</script>

<style scoped>
.sale-chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  font: var(--cl-caption);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  flex-shrink: 0;
  background: var(--cl-control-fill);
  color: var(--cl-label-85);
}
@media (pointer: coarse) {
  .sale-chip {
    height: 22px;
    border-radius: 11px;
  }
}
.sale-chip--price {
  background: var(--cl-accent-fill);
  color: var(--cl-accent-text-strong);
}
.sale-chip--muted {
  color: var(--cl-label-3);
}
.sale-chip--bonus {
  background: var(--cl-accent-fill);
  color: var(--cl-accent-text);
}
.sale-chip--owned {
  background: var(--cl-owned-fill);
  color: var(--cl-live-text);
}
</style>
